// extracted by mini-css-extract-plugin
export var cell = "_5w-4";
export var headerCell = "_5w-2";
export var rowHeader = "_5w-3";
export var table = "_5w-1";
export var tableContainer = "_5w-0";